import { Component, Input, OnInit } from '@angular/core';
import { EventDetail } from 'src/app/models/event/eventdetailsmodel';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-event-modal',
  templateUrl: './event-modal.component.html',
  styleUrls: ['./event-modal.component.css']
})
export class EventModalComponent implements OnInit {

  @Input() eventDetail: EventDetail;
  constructor(public util: UtilService) { }

  ngOnInit(): void {
  }

  get combinedHTML(): string {
    return '<h4 class="text-uppercase text-primary-darker d-inline text-left mb-0">Details: </h4>' + this.eventDetail.body;
  }

}
